import React from 'react';
import { alpha } from '@mui/material';
import { useBlendColors } from 'hooks/useDesign';

export const MuiCheckboxConfig = {
    defaultProps: {
        disableRipple: true,
        size: 'medium',
        icon: React.createElement('span', { className: 'CustomIconCheckbox CustomIconCheckbox--notChecked' }, null),
        checkedIcon: React.createElement('span', { className: 'CustomIconCheckbox CustomIconCheckbox--checked' }, null),
    },
    styleOverrides: {
        root: ({ theme }: { theme: any }) => {
            return {
                padding: '6px 8px',
                '& .CustomIconCheckbox': {
                    display: 'inline-block',
                    width: '16px',
                    height: '16px',
                    borderRadius: theme.shape.borderRadius,
                    backgroundColor: theme.palette.background.default,
                },
                '&.Mui-disabled': {
                    pointerEvents: 'auto',
                    input: {
                        pointerEvents: 'none',
                    },

                    '.CustomIconCheckbox--notChecked': {
                        backgroundColor: useBlendColors(alpha(theme.palette.text.primary, 0.16)),
                    },
                    '.CustomIconCheckbox--checked': {
                        backgroundImage: `url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='${alpha(theme.palette.text.primary, 0.16).replace('#', '%23')}' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13 0C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V3C0 1.34315 1.34315 0 3 0H13ZM11.9805 4.94043C11.793 4.75319 11.4891 4.75307 11.3018 4.94043L6.7998 9.44238L4.69824 7.34082C4.5108 7.15336 4.20698 7.15336 4.01953 7.34082L3.34082 8.01953C3.15338 8.20699 3.15338 8.5108 3.34082 8.69824L6.46094 11.8184C6.6484 12.0056 6.95225 12.0057 7.13965 11.8184L12.6592 6.29785C12.8466 6.11039 12.8466 5.80658 12.6592 5.61914L11.9805 4.94043Z'/%3E%3C/svg%3E%0A")`,
                    },
                    '& ~ .MuiFormControlLabel-label.Mui-disabled': {
                        color: alpha(theme.palette.text.primary, 0.8),
                    },
                },
                '&:not(.Mui-disabled)': {
                    '.CustomIconCheckbox--notChecked': {
                        border: `1px solid ${useBlendColors(alpha(theme.palette.text.primary, 0.4))}`,
                    },
                    '.CustomIconCheckbox--checked': {
                        backgroundImage: `url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='${theme.palette.primary.main.replace('#', '%23')}' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13 0C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V3C0 1.34315 1.34315 0 3 0H13ZM11.9805 4.94043C11.793 4.75319 11.4891 4.75307 11.3018 4.94043L6.7998 9.44238L4.69824 7.34082C4.5108 7.15336 4.20698 7.15336 4.01953 7.34082L3.34082 8.01953C3.15338 8.20699 3.15338 8.5108 3.34082 8.69824L6.46094 11.8184C6.6484 12.0056 6.95225 12.0057 7.13965 11.8184L12.6592 6.29785C12.8466 6.11039 12.8466 5.80658 12.6592 5.61914L11.9805 4.94043Z'/%3E%3C/svg%3E%0A")`,
                    },

                    '.MuiFormControlLabel-root:hover > & ~ .MuiFormControlLabel-label': {
                        color: alpha(theme.palette.primary.main, 0.8),
                    },
                    '&:hover .CustomIconCheckbox--notChecked, .MuiFormControlLabel-root:hover > & .CustomIconCheckbox--notChecked':
                        {
                            borderColor: useBlendColors(alpha(theme.palette.primary.main, 0.8)),
                            backgroundColor: useBlendColors(alpha(theme.palette.primary.main, 0.04)),
                        },
                    '&:hover .CustomIconCheckbox--checked, .MuiFormControlLabel-root:hover > & .CustomIconCheckbox--checked':
                        {
                            backgroundImage: `url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='${alpha(theme.palette.primary.main, 0.8).replace('#', '%23')}' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13 0C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V3C0 1.34315 1.34315 0 3 0H13ZM11.9805 4.94043C11.793 4.75319 11.4891 4.75307 11.3018 4.94043L6.7998 9.44238L4.69824 7.34082C4.5108 7.15336 4.20698 7.15336 4.01953 7.34082L3.34082 8.01953C3.15338 8.20699 3.15338 8.5108 3.34082 8.69824L6.46094 11.8184C6.6484 12.0056 6.95225 12.0057 7.13965 11.8184L12.6592 6.29785C12.8466 6.11039 12.8466 5.80658 12.6592 5.61914L11.9805 4.94043Z'/%3E%3C/svg%3E%0A")`,
                        },
                },
            };
        },
    },
};
